import AboutUs from "../components/aboutPage"
import AboutSection from "../components/aboutsection"
import Footer from "../components/footer"
import Header from "../components/header"

const Aboutus =()=>{
    return(
        <>
        {<Header/>}
        {<AboutUs/>}
        
        </>
    )
}
export default Aboutus